/* Acordeón del footer — solo en móvil.
   Los <details> vienen ABIERTOS del servidor a propósito: en desktop y sin JS
   la lista se ve completa. Esto únicamente los cierra por debajo de 750px, y
   los reabre al volver a desktop para que la rejilla no quede colapsada.
   No se toca el estado si el usuario ya abrió uno a mano en la misma anchura. */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  var accs = document.querySelectorAll('.wc-foot__acc');
  if (!accs.length) return;

  function sync(e) {
    var esMovil = e.matches;
    for (var i = 0; i < accs.length; i++) {
      accs[i].open = !esMovil;
    }
  }

  sync(mq);

  /* En desktop el <summary> no debe plegar nada: sin esto, un clic en el título
     de la columna colapsa la lista y deja un hueco en la rejilla del footer. */
  for (var j = 0; j < accs.length; j++) {
    var sum = accs[j].querySelector('summary');
    if (!sum) continue;
    sum.addEventListener('click', function (ev) {
      if (!mq.matches) ev.preventDefault();
    });
  }

  /* addEventListener('change') no existe en Safari < 14; addListener sí. */
  if (mq.addEventListener) {
    mq.addEventListener('change', sync);
  } else if (mq.addListener) {
    mq.addListener(sync);
  }
})();
